import React, { useEffect, useState } from 'react';
import Seo from '../components/Seo';
import { getPodcastEpisodes } from '../lib/api';
import { extractSpotifyEpisodeId } from '../lib/spotify';

function Podcast() {
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPodcastEpisodes()
      .then((data) => setEpisodes(data.episodes))
      .catch(() => setEpisodes([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <Seo title="Podcast — Entre Páginas" description="Entre Páginas: el podcast de Libros para Viajeros sobre libros, autores y viajes literarios." />
      <h1>Entre Páginas</h1>
      <p className="page__intro">
        El podcast de Libros para Viajeros: conversaciones sobre libros, autores y viajes literarios.
      </p>

      {!loading && episodes.length === 0 && (
        <p className="empty-state">Todavía no hay episodios publicados aquí.</p>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', maxWidth: '660px' }}>
        {episodes.map((episode) => {
          const spotifyId = extractSpotifyEpisodeId(episode.links?.spotify);
          return (
            <div key={episode.id}>
              {Boolean(episode.episode_number) && (
                <p className="content-card__category">Episodio {episode.episode_number}</p>
              )}
              <h3 style={{ marginTop: 0, marginBottom: '0.5rem' }}>{episode.title}</h3>
              {episode.description && <p style={{ marginTop: 0 }}>{episode.description}</p>}
              {spotifyId && (
                <iframe
                  title={episode.title}
                  src={`https://open.spotify.com/embed/episode/${spotifyId}?utm_source=generator`}
                  width="100%"
                  height="152"
                  style={{ borderRadius: '12px', border: 'none' }}
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Podcast;
